import { useTranslation } from "../hooks/useTranslation";
import { useAuthStore } from "../store/auth.store";
import { useEffect, useState } from "react";
import { useClaimsStore } from "../store/claims.store";
import { useClaims } from "../hook/partner/claims.partner.hook";
import { useBreadcrumbsStore } from "../store/breadcrumbs.store";
import { Pagination } from "../components/List/Pagination";
import { FulltextFilter } from "../components/List/FulltextFilter";
import { RowSelector } from "../components/List/RowSelector";
import ClaimTable from "../components/Claim/ClaimTable";
import { ClaimFilter } from "../components/Claim/ClaimFilter";
import { ClaimFilterActual } from "../components/Claim/ClaimFilterActual";

function Claims() {
  const { t } = useTranslation();

  const [filter, setFilter] = useState({
    fulltext: "",
    state: [],
    date_from: "",
    date_to: "",
  });

  const [page, setPage] = useState(1);
  const [sortTable, setSortTable] = useState({
    sort: "created_date",
    sortDirection: "desc",
  });
  const [rowsSelected, setRows] = useState(10);

  const claimsMutation = useClaims();
  const token = useAuthStore((state) => state.token);
  const claims = useClaimsStore((state) => state.claims);

  const setBreadcrumbs = useBreadcrumbsStore((state) => state.setBreadcrumbs);
  const setPagename = useBreadcrumbsStore((state) => state.setPagename);
  useEffect(() => {
    setPagename(t("claims.title"));
    setBreadcrumbs([]);
  }, []);

  useEffect(() => {
    if (token) {
      claimsMutation.mutate({
        token,
        page,
        filter,
        rowsSelected,
        sortTable,
      });
    }
  }, [token, page, filter, rowsSelected, sortTable]);

  useEffect(() => {
    setPage(1);
  }, [filter]);

  return (
    <>
      <div className="card mt-6">
        <div className="card-body border-0 pt-6">
          <div className="d-flex gap-2 justify-content-between">
            <div>
              <div className="card-toolbar">
                <div className="d-flex gap-2 align-items-center mb-2">
                  <FulltextFilter
                    onChange={(e) =>
                      setFilter({
                        ...filter,
                        fulltext: e.target.value,
                      })
                    }
                    placeholder={t("claims.searchClaim")}
                  />
                </div>
              </div>
            </div>
            <div>
              <div className="card-toolbar">
                <ClaimFilter filter={filter} setFilter={setFilter} />
              </div>
            </div>
          </div>
        </div>

        <div className="card-body pt-0" style={{ overflow: "auto" }}>
          <div className="border-top border-bottom py-3">
            {t("common.totalCount")}: {claims?.rows || 0}
          </div>
          <ClaimFilterActual setFilter={setFilter} filter={filter} />

          <ClaimTable claims={claims} />
        </div>
      </div>

      {claims?.rows > 0 && (
        <>
          <Pagination
            total_pages={claims.total_pages}
            rows_per_page={claims.rows_per_page}
            page={page}
            setPage={setPage}
          />

          <RowSelector setRows={setRows} />
        </>
      )}
    </>
  );
}

export default Claims;
